var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}],attrs:{"id":"app","img-set":"/static/favicon.png"}},[_c('keep-alive',{attrs:{"include":_vm.keepAliveComponents}},[(_vm.$route.name === 'Home')?_c('router-view',{key:_vm.snowId}):_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }